<template>
  <section class="page-body">

    <div class="page-title-bar sticky">
      <h1>{{ title }}</h1>

      <router-link :to="{ name: 'AddVenue' }" tag="button" class="btn" title="Add Venue">
        <i class="fa-thin fa-plus-circle"></i>
        Add Venue
      </router-link>
    </div>
    
    <div class="content-panel">
      <div class="panel-body no-title">
        <div class="data-table">
          <div class="data-table-search">
              <div class="actions">
                <span class="search-icon"><i class="fa-thin fa-search"></i></span>
                <input class="search-input" type="text" :placeholder="'Search Venues'" v-model="tableSearchTerm" />
              </div>
          </div>

          <vue-good-table
              :columns="columns"
              :rows="gridList"
              @on-row-click="viewPage"
              styleClass="vgt-table bookings-table"
              :sort-options="{
                  enabled: true,
                  initialSortBy: {field: 'featured', type: 'desc'}
              }"

              :search-options="{
                  enabled: true,
                  skipDiacritics: true,
                  externalQuery: tableSearchTerm
              }"

              :pagination-options="{
                  enabled: true,
                  mode: 'records',
                  perPage: 50,
                  position: 'bottom',
                  dropdownAllowAll: false,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
              }"
          >

              <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'name'">
                    <a title="View Venue"><strong>{{ props.row.name }}</strong></a>
                  </span>
                  <span v-else-if="props.column.field == 'featured'">
                    <span v-if="props.row.featured">Yes</span>
                    <span v-else>No</span>
                  </span>
                  <span v-else>
                      {{props.formattedRow[props.column.field]}}
                  </span>
              </template>

          </vue-good-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Venues',
  data() {
    return {
      title: 'All Venues',
      tableSearchTerm: '',
      columns: [
        {
          label: 'Name',
          field: 'name',
          tdClass: 'title-col',
        },
        {
          label: 'City',
          field: 'city',
        },
        {
          label: 'Featured',
          field: 'featured',
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
        db: 'db',
        gridList: 'getVenuesData'
    })
  },

  metaInfo: {
    title: 'All Venues'
  },

  async mounted() {
    let self = this;
    self.getGridData();
  },

  methods: {
    getGridData: async function(forceUpdate) {
      let self = this;

      if(!self.gridList.length || forceUpdate) {
        await self.$store.dispatch('bindVenuesData');
      }
    },

    viewPage: function(params) {
      let self = this;
      let id = params.row.id;

      self.$router.push({name: 'EditVenue', params:{ref:id}})
    }
  },

  watch: {
    'db': function() {
      let self = this;
      
      self.getGridData(true);
    }
  }
}
</script>
